import { defineMessages } from 'react-intl';

export default defineMessages({
  loadingMessage: {
    defaultMessage: 'Report Generating',
    id: 'eEi9A0',
    description: 'Insights Reports - Report Generating',
  },
  loadingSubtext: {
    defaultMessage: 'This can take over a minute, depending on the criteria selected.',
    id: 'vePtas',
    description: 'Insights Reports - Report subtext',
  },
  errorMessage: {
    defaultMessage: 'There was a problem generating your report.',
    id: 'Sa7F0C',
    description: 'Insights Reports - Report generation failed',
  },
  errorSubtext: {
    defaultMessage:
      'Please try a shorter date range or choose <b>Export to...</b> to export the report to a file. If this issue persists, please contact support for assistance.',
    id: 'srL9a8',
    description: 'Insights Reports - Report error subtext',
  },
  htmlTooLargeError: {
    defaultMessage:
      'The selected date range {errorSupplement} is too large for your chosen export method. Please select another option from the <b>Export to…</b> dropdown and try again.',
    id: '4XIeY1',
    description: 'Insights Reports - Report error subtext',
  },
});
